module.exports = __webpack_public_path__ + "static/media/welcome.42960017.jpg";